import { render, staticRenderFns } from "./DashWeekTopChart.vue?vue&type=template&id=f468a592&scoped=true"
import script from "./DashWeekTopChart.vue?vue&type=script&lang=js"
export * from "./DashWeekTopChart.vue?vue&type=script&lang=js"
import style0 from "./DashWeekTopChart.vue?vue&type=style&index=0&id=f468a592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f468a592",
  null
  
)

export default component.exports